module.exports = __webpack_public_path__ + "img/Ciceksepeti.76f709ff.png";